<template>
  <div>
    <v-slide-group
      v-if="items.length"
      v-model="categoriesSelecteds"
      class="mt-6 categories"
      show-arrows
    >
      <v-slide-item
        v-for="({ text, value }, keyItems) in items"
        :key="keyItems"
        :value="value"
        v-slot="{ active, toggle }"
      >
        <v-btn
          @click="toggle"
          class="text-body-1 text-none font-weight-medium rounded-lg"
          color="secondary lighten-4"
          :outlined="!active"
          depressed
        >
          {{ text }}
        </v-btn>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>

<script>
import { mixin } from "./mixin";
import { productFilter } from "../../../utils/productFilter";

const _config = {
  mod: "products-categories",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(({ id, title }) => ({
        text: title,
        value: Number(id),
      }));
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  mixins: [mixin, productFilter],
};
</script>

<style lang="scss" scoped>
.categories::v-deep {
  .v-slide-group__content {
    justify-content: center;
    gap: 8px;
  }
}
</style>
